import { useEffect } from 'react';

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title + ' - Raise My Funds';
  }, [title]);
};

export default useDocumentTitle;
